import React from "react";
import { AlertCircle, AlertTriangle, Info } from "lucide-react";

/**
 * The one container for anything the chat says ABOUT an answer rather than as
 * one: a run that stopped or failed, no credit, a caveat. A bordered, tinted
 * box like the page's error banner, not a coloured rule down the left edge,
 * which read as a stray line rather than a message.
 */
const TONES = {
  danger: { box: "bg-danger-soft border-danger", icon: "text-danger", Icon: AlertCircle },
  warning: { box: "bg-warning-soft border-warning", icon: "text-warning", Icon: AlertTriangle },
  neutral: { box: "bg-[color:var(--surface-sunken)] border-[color:var(--border-default)]", icon: "text-[color:var(--text-muted)]", Icon: Info },
};

export default function ChatNotice({ tone = "neutral", role = "note", className = "", children }) {
  const t = TONES[tone] || TONES.neutral;
  const { Icon } = t;
  return (
    <div role={role} className={`flex items-start gap-2.5 rounded-lg border px-3 py-2.5 ${t.box} ${className}`}>
      <Icon size={16} strokeWidth={2} className={`mt-[3px] shrink-0 ${t.icon}`} aria-hidden />
      <div className="min-w-0 flex-1 text-[color:var(--text-primary)]">{children}</div>
    </div>
  );
}
